export function isInvestorContactRequired(
  investorContactMandatory: string[] | undefined,
  offeringType: string | undefined
): boolean {
  return (
    !!investorContactMandatory?.length &&
    !!offeringType &&
    investorContactMandatory.includes(offeringType)
  );
}
